import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdateDocumentFlag() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.updateDocumentFlagDocumentsKeyFlagsFlagKeyPatchMutation(),
    onSuccess: (data, variables) => {
      const options = apiClient.getDocumentFlagsDocumentsKeyFlagsGetOptions({
        path: { key: variables.path.key },
      })

      queryClient.setQueryData(
        options.queryKey,
        (old: apiClient.DocumentFlagsResponse | undefined) => {
          if (!old) return old
          return {
            ...old,
            items: old.items.map((f) => (f.key === variables.path.flagKey ? data : f)),
          }
        },
      )

      queryClient.invalidateQueries(options)
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.path.key },
        }),
      )
    },
  })
}
